export default {"src":"/_next/static/image/public/images/card_world.53695a3b8766d1cc3f10d9a7c11cf0c2.svg","height":151,"width":378};